import { forwardRef, useState, memo } from 'react';

import NextImage from 'next/image';

const Image = forwardRef(({ src, alt, fallback, ...props }, ref) => {
  const [hasError, setHasError] = useState(false);

  return (
    <NextImage
      {...props}
      ref={ref}
      src={fallback && hasError ? fallback : src}
      alt={alt}
      onError={() => {
        setHasError(true);
      }}
    />
  );
});

Image.displayName = 'Image';

export default memo(Image);
